import providerwellbeing from './reducers/providerwellbeing';

export default {
    providerwellbeing: {
        reducer: providerwellbeing,
    },
};
